export default __webpack_public_path__ + "static/media/warning-filled.178b4e9a.svg";